<template>
  <span>
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
    ></loading>
    <v-card class="text-center">
      <v-card-title class="text-center">
        <v-spacer></v-spacer>
        <h2 class="text-center">{{ $t("other.paid_success") }}</h2>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-icon color="green" x-large> mdi-thumb-up-outline </v-icon>
        <p>{{ $t("other.paid_success_text") }})</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :to="{ path: `/dashboard` }">{{
          $t("other.to_main")
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
// moment.locale("ru");
export default {
  data: () => ({
    isLoading: false,
    error: "",
  }),
  created() {
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      // FT-067: общий result_success для всех Tinkoff-возвратов — подтверждаем привязку
      // карты ТОЛЬКО при флаге, выставленном attach_rebill_card (CON-04). Флаг чистим сразу,
      // чтобы confirm не повторился на reload и не сработал на обычных пополнениях/возвратах.
      if (localStorage.getItem("pending_card_binding")) {
        localStorage.removeItem("pending_card_binding");
        this.confirmAddCard();
      } else {
        this.refreshCompanyData();
      }
    }
  },
  methods: {
    // FT-067: подтверждение нулевой привязки карты после возврата с банк-формы.
    confirmAddCard() {
      this.isLoading = true;
      this.axios
        .post(
          "/api/v1/confirm_add_card",
          {},
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then((response) => {
          const status = response.data && response.data.status;
          if (status === "confirmed") {
            this.$notify(this.$t("transfers.card_bound_success"), "", "success");
          } else if (status === "pending") {
            this.$notify(this.$t("transfers.card_binding_pending"), "", "info");
          }
          // no_pending / superseded — тихо (повтор/конкурент)
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.card_binding"));
        })
        .finally(() => {
          this.refreshCompanyData();
        });
    },
    refreshCompanyData() {
      this.isLoading = true;
      let self = this;
      this.axios
        .get(`/api/v1/company`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.$store.commit("setCompany", { company: response.data });
          self.axios
            .get(`api/v1/main_companies/${response.data.main_company_id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response_main_company) => {
              this.$store.commit("setMainCompany", response_main_company.data);
            })
            .catch((error) => {
              self.isLoading = false;
              self.setError(error, self.$t("errors.main_company_data"));
              console.log(error);
            });
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.company_data"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
